export default function (entries, onViewError) {
  entries.forEach((entry) => {
    let xhr = new XMLHttpRequest()
    onViewError(() => xhr.abort())
    xhr.onload = () => {
      console.log('xhr.status', xhr.status)
      console.log('xhr', xhr)
      xhr.status === 200 ? entry.progress(100) : entry.error()
    }
    xhr.onerror = () => entry.error()

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        let percent = Math.round((event.loaded / event.total) * 100)
        if (percent < 100) {
          entry.progress(percent)
        }
      }
    })

    xhr.open('PUT', entry.meta.url, true)
    xhr.setRequestHeader('Cache-Control', '2592000')
    xhr.setRequestHeader('Content-Type', entry.file.type)
    xhr.send(entry.file)
    entry.progress(1)
  })
}
